// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1VbTz","choiceBoxes":"toolbarselects_choiceBoxes__8h6CJ","simpleField":"toolbarselects_simpleField__2DI0W"};